import { Container } from '@mui/material'
import { useLocation } from 'react-router-dom'
import Label from '../../../libs/rhf-mui/ui/Label'
import Title from '../../../libs/rhf-mui/ui/Title'

export type FrmErrorProps = {
  error_code: string,
  error_title: string,
  error_message: string
}

const FrmError = () => {
  let params = useLocation().state as FrmErrorProps;
  let error_code = params.error_code ?? "";
  let error_title = params.error_title ?? "";
  let error_message = params.error_message ?? "";

  return (
    <>
      <Container maxWidth={"md"}>
        <br /><br />
        <Title color='error'>ERROR!</Title>
        <br />
        <Title>{error_code}{error_code === "" ? "" : " "}{error_title}</Title>
        <Label>{error_message}</Label>
      </Container>
    </>
  )
}



export default FrmError